<template>
    <div v-if="article" class="article-wrap" :class="[`context-${getOpts.context}`]">
      <div class="article-main">
        <div class="article-wrap-body">
          <div class="publisher">
            <img :src="getLogo" onload="this.style.opacity = 1;"/>
            {{ getPublisher }}
          </div>

          <h1>{{ article.name }}</h1>

          <div class="meta-stack">
            <div v-if="story && story.sources > 0" class="meta-inner">
              <global-svg type="articles" width="11px"></global-svg>
              <span>{{story.sources}} sources</span>
            </div>
            <div class="meta-inner">
              <global-svg type="clock" height="11px"></global-svg>
              <span>{{article.minutes}} minute read</span>
            </div>
            <div class="meta-inner">
              <global-svg type="clock" height="11px"></global-svg>
              <span>{{article.published | ago }}</span>
            </div>
          </div>
          
          <div class="article-nutrition" v-if="nutrition">
            <div v-for="(item, idx) in nutrition" :key="idx" class="nutrition-item" :class="item.state" :data-value="item.abs">
              <div class="nutrition-group lead">
                <base-svg :svg="item.icon" height="1.5rem" />
                <span class="nutrition-count">{{ item.value }}</span>
              </div>
              <div class="nutrition-group detail">
                <span class="nutrition-label">{{ item.label }}</span>
                <span class="nutrition-byline">{{ item.byline }}</span>
              </div>
            </div>
          </div>

          <div class="article-image">
            <img :src="getBestImage"/>
          </div>

          <div class="article-content" v-html="getSnippet"></div>

          <button class="article-link" @click="didSelectFullArticle(article, storySlug)">Continue reading on {{ article.publisher.name }}</button>
        </div>
      </div>
      
      <div class="article-aside">
        <!-- <div class="aside-section">
          <h4>Article nutrition</h4>
          <div class="article-nutrition">
            <div v-for="(item, idx) in nutrition" :key="idx" class="nutrition-item" :class="item.state" :data-value="item.abs">
              <span class="nutrition-count">{{ item.value }}</span>
              <div class="nutrition-label">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div> -->

        <div class="article-chart aside-section" v-if="article">
          <h4 v-if="topTopics.length">Topic Analysis</h4>
          <analysis-grid v-if="topTopics.length" :data="topTopics"></analysis-grid>
          <h4 v-if="topGeographies.length">Regional Analysis</h4>
          <analysis-grid v-if="topGeographies.length" :data="topGeographies"></analysis-grid>
        </div>

        <div v-if="getAlternatives(0,4).length" class="alternative-articles xx--grid-a aside-section">
          <div v-for="(article, idx) in getAlternatives(0,4)" :key="idx+4" class="grid-stack" v-bind:class="['grid-stack-'+(idx+4)]">
            <div class="grid-stack-inner">
              <story-stretch-small class="border-right" hideUpdated="true" :withinStory="article.slug" :story="story"></story-stretch-small>
            </div>
          </div>
        </div>

        <div v-if="getAlternatives(4,99).length" class="max-width aside-section">
          <h3>Alternative Sources</h3>
        </div>
        
        <div v-if="getAlternatives(4,99).length" class="max-width alternative-articles grid-b aside-section">
          <div v-for="(article, idx) in getAlternatives(4,99)" :key="idx+4" class="grid-stack" v-bind:class="['grid-stack-'+(idx+6)]">
            <div class="grid-stack-inner">
              <story-stacked-single class="border-right" hideUpdated="true" :withinStory="article.slug" :story="story"></story-stacked-single>
            </div>
          </div>
        </div>
        
        <excluded-publisher></excluded-publisher>
      </div>
  </div>
</template>

<script>
import API from 'app/axios';
import { Mixins } from '../components/Grid/mixins'
import AnalysisGrid from 'app/components/AnalysisGrid';
// import ArticleProgress from 'app/components/ArticleProgress';
// import SubscriptionCta from 'app/components/Subscriptions/SubscriptionCTA';
import StoryStackedSingle from 'app/components/Grid/stacks/StackedSingle';
import StoryStretchSmall from 'app/components/Grid/stacks/StretchSmall';
import ExcludedPublisher from "app/components/ExcludedPublishers/ExcludedPublisher";
// import BaseCta from 'app/components/CallsToAction/BaseCTA';

export default {
    components: {
        AnalysisGrid,
        // ArticleProgress,
        // SubscriptionCta,
        StoryStackedSingle,
        StoryStretchSmall,
        ExcludedPublisher,
        // BaseCta
    },
    props: {
      // v5 - in Stack hack
      opts: Object,
    },
    mixins: [Mixins],
    data() {
        return {
            // articleSlug: this.$route.params.article || '-',
            // storySlug: this.$route.params.story || '-',
        }
    },
    mounted() {
      console.log('LOADED', this.opts);

      if (this.storySlug != '-'){
        API.getStory(this.storySlug);
      }

      API.getArticle(this.articleSlug);
      if (this.articleSlug.title) {
          window.document.title = this.articleSlug.title;
      }

      if (!this.loggedIn) {
        if (Math.random() >= 0.75) {
          this.EventBus.$emit('showInboundMessage', {
            code: 'SIU001',
            callback: (code) => {
              if (code == 'sign-up'){
                this.$store.commit("updateShowModal", 'skip');
              }
              if (code == 'cancel'){
                return;
              }
            }
          });
        }
      }

      // NB -- You can't put stuff that relies on article. or story. here.. 
      //       See the watcher, below, that waits for data to hit.
      this.EventBus.$on("didAddExcludedPublisher", (payload) => {
        this.didSelectArticle(payload.article, payload.storySlug);
      });
    },
    computed: {
      storySlug() {
        // return this.opts?.story || this.$route.params.story || '-';
        return this.$route.params.story || '-';
      },
      articleSlug() {
        // return this.opts?.slug || this.$route.params.article || '-';
        return this.$route.params.article || this.opts.slug || '-';
      },
      getOpts() {
        return this.opts || {};
      },
      hasThreads() {
        return this.$store.getters.hasThreads;
      },
      isLoggedIn() {
          return this.$store.getters.isLoggedIn;
      },
      showProPromo() {
          return this.$store.getters.showProPromo;
      },
      // Rendering stops till this returns.. 
      article() {
          return this.$store.getters.getArticle(this.articleSlug);
      },
      nutrition() {
        const nutrition = this.article.nutrition || null

        if (!nutrition) { return null }

        return {
          calories: {
            icon: 'meta-flame',
            label: 'Calorie',
            byline: `Overall value`,
            abs: nutrition.calories || 0,
            value: nutrition.calories >= 500 ? 'high' : (nutrition.calories >= 200 ? 'med' : 'low'),
            state: nutrition.calories >= 500 ? 'amber' : (nutrition.calories >= 200 ? 'green' : 'amber'),
          },
          protein: {
            icon: 'meta-meat',
            label: 'Protein',
            byline: 'Facts & evidence',
            abs: nutrition.protein || 0,
            value: nutrition.protein >= .75 ? 'high' : (nutrition.protein >= .25 ? 'med' : 'low'),
            state: nutrition.protein >= .75 ? 'green' : (nutrition.protein >= .25 ? 'amber' : 'red'),
          },
          salt: {
            icon: 'meta-salt',
            label: 'Salt',
            byline: 'Snark & ragebait',
            abs: nutrition.salt || 0,
            value: nutrition.salt >= .75 ? 'high' : (nutrition.salt >= .25 ? 'med' : 'low'),
            state: nutrition.salt >= .75 ? 'red' : (nutrition.salt >= .25 ? 'amber' : 'green'),
          },
          sugar: {
            icon: 'meta-sweet',
            label: 'Sugar',
            byline: 'Clickbait & trivia',
            abs: nutrition.sugar || 0,
            value: nutrition.sugar >= .75 ? 'high' : (nutrition.sugar >= .25 ? 'med' : 'low'),
            state: nutrition.sugar >= .75 ? 'red' : (nutrition.sugar >= .25 ? 'amber' : 'green'),
          },
          fat: {
            icon: 'meta-pig',
            label: 'Fat',
            byline: 'Low value bulk',
            abs: nutrition.fat || 0,
            value: nutrition.fat >= .75 ? 'high' : (nutrition.fat >= .25 ? 'med' : 'low'),
            state: nutrition.fat >= .75 ? 'red' : (nutrition.fat >= .25 ? 'amber' : 'green'),
          },
        }
      },
      // Optional ('-' signifies orphan article -- quite common)
      story() {
        if (this.article){
          if (this.storySlug !== '-' && this.storySlug !== undefined) {
            return this.$store.getters.getStory(this.storySlug);
          } else if (this.article?.stories?.length) {
            API.getStory(this.article?.stories[0].slug);
            return this.$store.getters.getStory(this.article?.stories[0].slug);
          }
        }
        return null;
      },
      getLogo() {
        if (this.article) {
          return this.article.publisher.icon || false;
        }
        return null;
      },
      getPublisher() {
        if (this.article) {
          return this.article.publisher.name || false;
        }
        return null;
      },
      getSnippet() {
        // console.log(this.article);
        // return this.article.synopsis + '&hellip;';
        let sFormatted = '...';
        if (this.article?.sample?.length){
          sFormatted = this.article?.sample?.map(s => {return '<p class="article-para">' + s + '</p>';}).join('');
        }
        return sFormatted;
      },
      getBestImage() {
        
        // if we have a good image, fine
        if (this.article.image && (this.article.image.search(/article-fallback/) == -1)){
          // console.log('Image: Article: ', this.article.image);
          return this.article.image;
        }

        // if we have a story, great.. 
        if (this?.story?.image && (this.story.image.search(/article-fallback/) == -1)){
          // console.log('Image: Story: ', this.story.image);
          return this.story.image;
        }

        // console.log('Image: Fail');
        // then nothing is better than the placeholder..
        return '/r/i/pix.gif';
      },
      topTopics(){
        return this.article.topics.filter(t => !['location'].includes(t.icon)).filter(t => t?.sentiment?.counts?.links).slice(0,10);
      },
      topGeographies(){
        return this.article.topics.filter(t => ['location'].includes(t.icon)).filter(t => t?.sentiment?.counts?.links).slice(0,5);
      },
      isAlpha() {
        return this.$store.getters.isAlpha;
      },
      getUserLayout() {
          return 'layout_b'; // this.$store.getters.getUserLayout;
      },
      loggedIn() {
        return this.$store.getters.isLoggedIn;
      },
    },
    methods: {
      deviceMessage(sMode, oData){
          this.EventBus.$emit("appCallback", {
            type: sMode,
          data: oData || {}
        });
      },
      
      deviceLog(sMessage){
          this.deviceMessage('consoleXCode',{
            message: sMessage,
          });
      },

      getAlternatives(iStart, iEnd) {
        if (!this.story) {
            return [];
        }
        let alternativeArticles = this.story.alternative_articles || [];
        let links = this.story.links || [];
        return [...alternativeArticles, ...links].slice(iStart, iEnd);
      },
      didSelectFullArticle(article, storySlug) {
        // Message to parent, if present.. 
        // window.parent && window.parent.postMessage({action:'close-preview'},'*');
        // and back away from here if we're sticking around.. 
        // this.$router.back();
        
        if (this.$store.getters.hasIOSApp) {
          // Fetch excluded publishers from store
          const article = this.$store.getters.getArticle(this.articleSlug);
          const excludedPublishers = this.$store.getters.getExcludedPublishers;

          // Loop through excluded publishers to check if article publisher is excluded
          if (excludedPublishers) {
            let matched = false;
            excludedPublishers.forEach(publisherCode => {
                if (article.publisher.code) {
                    if (article.publisher.code === publisherCode) {
                        // Match found, show overlay
                        matched = true;
                        this.EventBus.$emit("handleExcludedPublisher", {
                            publisher: article.publisher,
                            article: article,
                            storySlug: storySlug
                        });
                        return;
                    }
                }
            });

            if (!matched) {
              this.didSelectArticle(article, storySlug);
            }
          } else {
            this.didSelectArticle(article, storySlug);
          }
        } else {
          this.didSelectArticle(article, storySlug);
        }
      },
      trackPreview(){
        this.EventBus.$emit("deviceLog", 'Preview: trackArticleAction');
        // Load has completed
        let payload = {
          src: this,
          article: this.article,
          story: this.story,
          state: 'preview'
        };

        // Add event if event is defined
        if (event) { payload.event = event }

        // debug & fire..
        this.EventBus.$emit("trackArticleAction", payload);
      },
      checkIOSApp() {
          return this.$store.getters.hasIOSApp;
      },
      goThreadShare() {
          if (this.isLoggedIn && this.hasThreads) {
            // Signed in and thread active
            this.EventBus.$emit('thread:share', {
                on: true,
                link: this.article.url,
            });
          } else {
            // Not signed in or not thread active
            this.$router.push(`/threads`);
          }
      },
    },
    watch: {
      article: function (oNew, oOld) {
        this.EventBus.$emit("deviceLog", 'Article object updated..');
        if (oNew !== oOld){
          this.EventBus.$emit("deviceLog", 'Preview: trackArticleAction');
          this.trackPreview();
        }
      }
    }
}
</script>

<style lang="scss" scoped>
    @import '~styles/_variables';
    @import 'src/assets/scss/__v6.scss';

    .context-stack {
      margin-bottom: 3rem;
    }


    .max-width {
        max-width: 1100px;

        @media (max-width: 770px) {
            margin: 0;
        }
    }

    .cta-wrapper {
        margin-top: 30px;
    }

    .is-button {
        margin: 0;
        margin-right: auto;
    }

    h4 {
      font-weight: bold;
      font-size: 1rem;
    }
    
    .article-header {
        display: flex;
        justify-content: center;
        // background: $base-primary;

        // .darkmode & {
        //   background: $neutral-300;
        // }
        
        // margin: -1em -1em 0 -1em;
        // padding: 60px 15px 0 15px;
        margin-top: 60px;

        @media (max-width: 770px) {
            flex-direction: column;
        }

        @media (max-width: 475px) {
            flex-direction: column-reverse;
            padding: 0;
            // margin-top: -30px;
            position: relative;
            margin-top: 0;
        }

        .article-header-inner {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 100px;
            padding: 0 1rem;

            @media (max-width: 770px) {
                grid-template-columns: 1fr;
                grid-gap: 30px;
            }

            @media (max-width: 475px) {
              padding: 0;
            }
        }

        .article-lead {
          align-self: center; 
          
          @media (max-width: 475px) {
            grid-row: 2;
            padding: 0 1rem;
          }
        }

        .article-meta {
            display: flex;
            flex-direction: row;
            font-family: $ff-tag;
            font-weight: bold;
            font-size: 14px;
            // margin-bottom: 30px;
            justify-content: space-between;
            margin-right: 40px;

            .meta-stack {
                display: flex;
            }

            .meta-inner {
              display: flex;
              align-items: center;
              margin-right: 20px;

              &.no-margin {
                  margin-right: 0;
              }

              &.mobile-hide {
                @media (max-width: 475px) {
                    display: none;
                }
              }
            }
            .meta-tool {
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
            }

            span {
                margin-left: 8px;
            }

            @media (max-width: 475px) {
                padding: 0;
                margin-right: 0;
            }
        }

        .article-image {
            height: 325px;
            border-radius: 5px;
            cursor: pointer;
            z-index: 5;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 5px;

                @media (max-width: 770px) {
                    margin-top: 0;
                }
            }

            @media (max-width: 770px) {
                height: 235px;
            }

            @media (max-width: 475px) {
                border-radius: 0;

                img {
                  border-radius: 0;
                }
            }
        }

        .article-heading {
            font-size: 32px;
            line-height: 1.3;
            padding: 20px 20px 20px 0;
            max-width: 600px;
            cursor: pointer;

            font-family: $ff-headline;
            
            span {
              font-weight: bold;
            }
            
            @media (max-width: 475px) {
                z-index: 10;
                border-radius: $border-radius;
                bottom: -100px;
                margin: 0;
                font-size: 1.5rem;
            }
        }
    }

    .publisher {
      display: flex;
      align-items: center;
      color: $neutral-100;
      font-size: 1rem;
      font-weight: bold;

      .darkmode & {
        color: $neutral-600;
      }

      img {
        width: 28px;
        height: 28px;
        border-radius: 500px;
        margin-right: 0.75rem;
        opacity: 0;
        transition: all .3s;
      }
    }
    
    .article-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 100px;
        padding: 90px 1rem;

        .publisher-logo {
          max-width: 220px;
          max-height: 60px;
          object-fit: contain;
        }

        &.no-margin {
            margin-top: 0;
        }

        @media (max-width: 770px) {
            grid-template-columns: 1fr;
            grid-gap: 60px;
            padding: 40px 1rem 40px 1rem;
        }

        @media (max-width: 475px) {
            grid-gap: 30px;
        }
    }
    
    .intro-stack {
        display: flex;
        flex-direction: column;
        width: 100%;

        .publisher-logo {
            display: flex;
            justify-content: flex-start;
        }

        .article-body {
          font-size: 18px;
          line-height: calc(1.5em + .2vw);
          letter-spacing: -0.01em;
          word-break: break-word;
          text-align: left;
          color: $base-primary;
          padding: 0 0 30px 0;
          // cursor: pointer;

          .darkmode & {
            color: $white-primary;
          }
        }

        .article-hidden {
            max-height: 250px;
            overflow: hidden;
        }
    }

    .article-chart {
        width: 100%;

      
    }

    .article-progress {
        position: fixed;
        background: $white-primary;
        width: 100%;
        left: 0;
        bottom: 0;
        z-index: 10;

        @media (min-width: 770px) {
          position: relative;
          margin-top: 5em;
        }
    }

    .alternative-articles {
        display: grid;
        grid-gap: 30px;
        margin-top: 30px;

        &.grid-a {
            grid-template-columns: 1fr 1fr;
            grid-gap: 15px;

            @media (max-width: 900px) {
                grid-template-columns: 1fr;
            }

            @media (max-width: 770px) {
                grid-template-columns: 1fr 1fr;
            }
        }

        &.grid-b {
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-gap: 30px;

            @media (max-width: 960px) {
                grid-template-columns: 1fr 1fr 1fr;
                grid-gap: 15px;
            }

            @media (max-width: 660px) {
                grid-template-columns: 1fr 1fr;
            }
        }

        .grid-stack-inner {
            background: $base-border-background;
            height: 100%;
        }
    }


  .article-wrap {
    position: relative;
    max-width: $desktop-max-width;
    margin: 0 auto;
    display: grid;
    grid-template-columns: $desktop-grid-main $desktop-grid-aside;
    height: $desktop-grid-height;
    overflow: hidden;
    border-left: 1px solid rgba($neutral-400, 0.25);
    border-right: 1px solid rgba($neutral-400, 0.25);

    @media (max-width: 850px) {
      grid-template-columns: 1fr;
      height: auto;
      border-left: unset;
      border-right: unset;
    }

    .article-main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1.5rem;
      height: $desktop-grid-height;
      overflow-y: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        display: none;
      }

      @media (max-width: 850px) {
        height: auto;
        grid-row: 1;
      }

      .article-wrap-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 1.5rem;
        position: relative;
        width: 100%;
        grid-column: span 1;
        padding: 2.5rem 2rem 3rem 2rem;

        &[data-index="0"] {
          margin-top: 0;
        }

        @media (max-width: 850px) {
          padding: 2rem 1rem 2.5rem 1rem;
        }
      }

      h1 {
        font-family: 'Brawler';
        font-weight: normal;
        font-size: 2rem;
        line-height: 125%;
      }

      .meta-stack {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 1rem;
        width: 100%;

        .meta-inner {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 0.5rem;
        }
      }

      .article-link {
        margin-bottom: 1rem;
      }

      .article-content {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        ::v-deep {
          p {
            font-size: 1.2rem;
            line-height: 1.8em;
            margin-bottom: 0;
          }
        }
      }

      .article-image {
        height: 400px;
        min-height: 400px;
        position: relative;
        border-radius: $el-border-radius;
        overflow: hidden;

        .mobile & {
          height: 250px;
          min-height: 250px;
          // padding-left: 0.8em;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }
      }
    }

    .article-aside {
      order: 2;
      grid-column: span 1;
      display: flex;
      flex-direction: column;
      height: $desktop-grid-height;
      flex: 1;
      border-left: 1px solid rgba($neutral-400, 0.25);
      overflow-y: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        display: none;
      }

      .mobile & {
        max-width: 100%;
        margin: 0;
        grid-row: span 1 / auto !important; 
        order: -1;
        height: auto;
      }

      @media (max-width: 850px) {
        border-top: 1px solid rgba($neutral-400, 0.25);
        border-left: 0;
        padding-bottom: 4.1rem;
      }

      .aside-section {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1.7rem 1rem 2rem 1rem;
        border-bottom: 1px solid rgba($neutral-400, 0.25);
        background: $neutral-600;

        .darkmode & {
          background: $neutral-100;
        }

        .desktop & {
          .darkmode & {
            background: $neutral-200;
          }
        }
      }
    }

    .article-nutrition {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      width: 100%;
      margin: 1rem 0;
      overflow-x: scroll;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        display: none;
      }

      .nutrition-item {
        display: flex;
        flex-direction: column;
        // gap: 1.2rem;
        width: 100%;
        min-width: 8rem;
        max-width: 8rem;
        padding: 1rem;
        border-radius: 15px;
        background: radial-gradient(circle at bottom right, rgba($neutral-400, 0.2), rgba($neutral-400, 0.05) 70%);

        .nutrition-group {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.75rem;

          &.lead {
            flex-direction: row-reverse;
            justify-content: space-between;
          }
        }

        svg {
          fill: $neutral-400;
        }

        .nutrition-count {
          font-size: 1.1rem;
          font-weight: bold;
          text-transform: capitalize;
          color: $neutral-400;
        }

        .nutrition-label {
          font-size: 0.9rem;
          font-weight: bold;
          color: $neutral-400;
          opacity: .7;
        }

        .nutrition-byline {
          font-size: 0.75rem;
          color: rgba($neutral-600, .35);
          text-wrap: balance;
        }

        &.red {
          background: radial-gradient(circle at bottom right, rgba($red-tone-3, 0.2), rgba($red-tone-3, 0.05) 70%);

          svg {
            fill: $red-tone-3;
          }

          .nutrition-count,
          .nutrition-label {
            color: $red-tone-3;
          }
        }

        &.amber {
          background: radial-gradient(circle at bottom right, rgba($orange-tone-3, 0.2), rgba($orange-tone-3, 0.05) 70%);

          svg {
            fill: $orange-tone-3;
          }

          .nutrition-count,
          .nutrition-label {
            color: $orange-tone-3;
          }
        }

        &.green {
          background: radial-gradient(circle at bottom right, rgba($green-tone-3, 0.2), rgba($green-tone-3, 0.05) 70%);

          svg {
            fill: $green-tone-3;
          }

          .nutrition-count,
          .nutrition-label {
            color: $green-tone-3;
          }
        }
      }
    }
  }
</style>